import { FC } from "react";
import {
  InputEmail,
  InputText,
  ExtendedTag,
  Form,
  Button,
  FormattedMessage,
  Drawer,
  AsyncSelect,
} from "components";
import { getQueryKey } from "utils";
import { Account, Staff, QueryKey } from "types";
import { useMutation } from "hooks";

interface FormValues {
  fistName: string;
  lastName: string;
  email: string;
  accountID: number;
}

interface CreateNewProps {
  staffListQueryKey: QueryKey;
  drawerOpen: boolean;
  onClose: () => void;
}

const CreateNew: FC<CreateNewProps> = ({
  drawerOpen,
  onClose,
  staffListQueryKey,
}) => {
  const [form] = Form.useForm();
  const { mutate, isPending } = useMutation<Staff, FormValues>({
    method: "post",
    apiName: "staff",
    invalidateQueries: [staffListQueryKey],
    onSuccess: () => onClose(),
  });

  return (
    <Drawer
      open={drawerOpen}
      onClose={onClose}
      destroyOnClose
      extra={
        <Button
          type="primary"
          loading={isPending}
          onClick={() => form.submit()}
        >
          <FormattedMessage id="button.submit" />
        </Button>
      }
    >
      <Form<FormValues>
        form={form}
        preserve={false}
        layout="vertical"
        onFinish={(values) => mutate(values)}
      >
        <InputText required name="first_name" label="common.first_name" />
        <InputText required name="last_name" label="common.last_name" />
        <InputEmail required name="email" label="common.email" />
        <AsyncSelect<Account>
          required
          name="account_id"
          label="common.account"
          apiName="accounts"
          queryKey={getQueryKey("accountList")}
          getOptionProps={(opt) => ({
            value: opt.id,
            children: (
              <ExtendedTag backgroundColor={opt.color}>
                {opt.account_name}
              </ExtendedTag>
            ),
          })}
        />
      </Form>
    </Drawer>
  );
};

export default CreateNew;
